import { Component } from '@angular/core';
import { ArrayWidget as _ArrayWidget } from '../angular2-schema-form-shim';
import { JSONSchema } from '../types/json-schema';
import { isWidgetRequired } from './overrides';

@Component( {
  selector: 'sp-array-widget',
  templateUrl: './array.widget.html',
} )
export class ArrayWidget extends _ArrayWidget {
  schema: JSONSchema;

  get required() {
    return isWidgetRequired( this );
  }
}



// WEBPACK FOOTER //
// /var/www/schemas-forms/src/app/widgets/array.widget.ts